import axios from "axios";
import { logout, refreshToken } from "../session";

export async function readStickyNotification(count: number, id: string) {
    try {
      const jwt = localStorage.getItem('jwt');
      await axios.patch(`https://api.abogalia.com.ar/abogalia/api/v1/users/notifications/${id}`, 
        {
          is_read: true,
        },
        {
          headers: {
            Authorization: `Bearer ${jwt}`,
            Accept: 'application/json',
          },
        }
      );
    } catch (error: any) {
      if (error.response && error.response.status === 401 && count === 0) {
        const shouldRetry = await refreshToken(null);
        if (shouldRetry) {
          await readStickyNotification(1, id);
        }
      } else {
        console.log(`error reading sticky notification with id ${id}: `, error);
      }
    }
}

export async function registerPushToken(count: number, token: string): Promise<boolean> {
    try {
        const jwt = localStorage.getItem('jwt');
        await axios.post(
            'https://api.abogalia.com.ar/abogalia/api/v1/users/notifications/push-token',
            { token },
            {
                headers: {
                    Authorization: `Bearer ${jwt}`,
                    Accept: 'application/json',
                },
            }
        );
        return true;
    } catch (error: any) {
        if (error.response && error.response.status === 401 && count === 0) {
            const shouldRetry = await refreshToken(null);
            if (shouldRetry) {
                return registerPushToken(1, token);
            } else {
                logout(null);
            }
        }
        console.log('Error registering push token:', error);
        return false;
    }
}